import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const column: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};
